import { Icon } from '../Icon';
import type { ActiveTab, UserRole } from '../../types';

interface TabNavProps {
    activeTab: ActiveTab;
    setActiveTab: (tab: ActiveTab) => void;
    role: UserRole;
}

export function TabNav({ activeTab, setActiveTab, role }: TabNavProps) {
    return (
        <div className="flex border-b border-slate-200 mb-8 overflow-x-auto">
            <button
                onClick={() => setActiveTab('tasks')}
                className={`px-5 py-3 font-semibold text-sm border-b-2 whitespace-nowrap transition-all flex items-center gap-2 ${activeTab === 'tasks' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
            >
                <Icon name="clipboard-list" className="w-4 h-4" /> 중점 과제 설정 & 관리
            </button>

            {(role === 'EVALUATOR' || role === 'HR') && (
                <button
                    onClick={() => setActiveTab('review')}
                    className={`px-5 py-3 font-semibold text-sm border-b-2 whitespace-nowrap transition-all flex items-center gap-2 ${activeTab === 'review' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
                >
                    <Icon name="trending-up" className="w-4 h-4" /> 상시/분기 실적 환산 시뮬레이터
                </button>
            )}

            <button
                onClick={() => setActiveTab('peer-eval')}
                className={`px-5 py-3 font-semibold text-sm border-b-2 whitespace-nowrap transition-all flex items-center gap-2 ${activeTab === 'peer-eval' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
            >
                <Icon name="users" className="w-4 h-4" /> 일하는 방식 다면평가 <span className="bg-indigo-100 text-indigo-700 text-[10px] px-2 py-0.5 rounded-full font-bold">NEW</span>
            </button>

            {(role === 'EVALUATOR' || role === 'HR') && (
                <button
                    onClick={() => setActiveTab('calibration')}
                    className={`px-5 py-3 font-semibold text-sm border-b-2 whitespace-nowrap transition-all flex items-center gap-2 ${activeTab === 'calibration' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
                >
                    <Icon name="settings" className="w-4 h-4" /> Calibration & 9-Block
                </button>
            )}

            {role === 'HR' && (
                <button
                    onClick={() => setActiveTab('monitor')}
                    className={`px-5 py-3 font-semibold text-sm border-b-2 whitespace-nowrap transition-all flex items-center gap-2 ${activeTab === 'monitor' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
                >
                    <Icon name="bar-chart-2" className="w-4 h-4" /> HR 모니터링
                </button>
            )}

            {role === 'HR' && (
                <button
                    onClick={() => setActiveTab('admin')}
                    className={`px-5 py-3 font-semibold text-sm border-b-2 whitespace-nowrap transition-all flex items-center gap-2 ${activeTab === 'admin' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
                >
                    <Icon name="building" className="w-4 h-4" /> HR 어드민 통제 센터
                </button>
            )}
        </div>
    );
}
